<template>
  <div>
    <div class="gmsqDialog">
      <div class="formmes">
        <el-form ref="form" :model="form" :rules="rules">
          <div class="imgtitle1" style="position: relative">
            <div
              v-preventReClick
              style="
                position: absolute;
                right: 30px;
                top: 30px;
                font-size: 30px;
                color: #606266;
                cursor: pointer;
              "
              @click="back"
            >
              <i class="el-icon-circle-close" />
            </div>
            <img src="../../assets/img/hhwhc.png" alt="">
          </div>
          <div class="firstbf">
            <el-form-item label="化学品:" prop="hxpBm">
              <!-- 甲苯混合物、丙酮混合物、丁酮混合物、硫酸混合物、盐酸混合物 -->
              <el-select
                v-model="form.hxpBm"
                placeholder="请选择化学品"
                :disabled="gmsqtype"
              >
                <el-option
                  v-for="item in yzd_nsjsl_dw"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="混合物浓度:" prop="hhwnd" required>
              <el-input
                v-model="form.hhwnd"
                suffix-icon="%"
                :disabled="gmsqtype"
                placeholder="请输入浓度数值"
              />
            </el-form-item>
            <el-form-item label="购买数量:" prop="gmslxg">
              <el-input
                v-model="form.gmsl"
                :disabled="gmsqtype"
                placeholder="请输入购买数量"
              />
              <el-select
                v-model="form.gmslDw"
                placeholder="请选择单位"
                :disabled="gmsqtype"
              >
                <el-option
                  v-for="item in yzd_nsjsl_dw"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="单价:" prop="djxg">
              <el-input
                v-model="form.dj"
                :disabled="gmsqtype"
                placeholder="请输入单价"
              />
              <el-select
                v-model="form.djDw"
                placeholder="请选择单位"
                :disabled="gmsqtype"
              >
                <el-option
                  v-for="item in yzd_zjzj"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="总价:" prop="zjxg">
              <el-input
                v-model="form.zj"
                :disabled="gmsqtype"
                placeholder="请输入总价"
              />
              <el-select
                v-model="form.zjDw"
                placeholder="请选择单位"
                :disabled="gmsqtype"
              >
                <el-option
                  v-for="item in yzd_zjzj"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="年需求量:" prop="nxqlxg">
              <el-input
                v-model="form.nxql"
                :disabled="gmsqtype"
                placeholder="请输入年需求量"
              />
              <el-select
                v-model="form.nxqlDw"
                placeholder="请选择单位"
                :disabled="gmsqtype"
              >
                <el-option
                  v-for="item in yzd_nsjsl_dw"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="用途:" prop="yt">
              <el-input
                v-model="form.yt"
                :disabled="gmsqtype"
                placeholder="请输入用途"
              />
            </el-form-item>
            <el-form-item label="购销合同号:" prop="gxhth">
              <el-input
                v-model="form.gxhth"
                :disabled="gmsqtype"
                placeholder="请输入购销合同号"
                @blur="gxhthImage($event.target.value)"
              />
            </el-form-item>
            <el-form-item label="有效次数:" prop="yxcs">
              <el-switch
                v-model="form.yxcs"
                :disabled="gmsqtype"
                active-text="一次有效"
                inactive-text="多次有效"
              />
            </el-form-item>
            <el-form-item label="经办人姓名:" prop="jbrXm">
              <el-select
                v-model="form.jbrXm"
                filterable
                :disabled="gmsqtype"
                placeholder="请输入经办人姓名"
                clearable
                @change="jbrChange"
              >
                <el-option
                  v-for="item in jbrList"
                  :key="item.id"
                  :label="item.xm"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="经办人身份证:" prop="jbrSfzh">
              <el-input
                v-model="form.jbrSfzh"
                :disabled="gmsqtype"
                placeholder="请输入经办人身份证"
              />
            </el-form-item>
            <el-form-item label="经办人手机号:" prop="jbrSjh">
              <el-input
                v-model="form.jbrSjh"
                :disabled="gmsqtype"
                placeholder="请输入经办人手机号码"
              />
            </el-form-item>
            <el-form-item label="备注:" prop="bz">
              <el-input
                v-model="form.bz"
                :disabled="gmsqtype"
                placeholder="请输入"
              />
            </el-form-item>
          </div>
          <div class="imgtitle2">
            <img src="../../assets/img/xsdwxx.png" alt="">
          </div>
          <div class="secondbf">
            <el-form-item label="单位名称:" prop="xsdwMc">
              <el-input
                v-model="form.xsdwMc"
                :disabled="gmsqtype"
                placeholder="请输入或选择单位名称"
              />
              <!-- @change="addDW($event)" -->
              <el-button
                v-preventReClick
                type="primary"
                style="background: #4170ff"
                :disabled="gmsqtype"
                @click="selectdwmc()"
              >选择</el-button>
            </el-form-item>
            <el-form-item label="统一社会信用代码:" prop="xsdwTyshxydm">
              <el-input
                v-model="form.xsdwTyshxydm"
                :disabled="gmsqtype"
                placeholder="请输入"
              />
            </el-form-item>
            <el-form-item label="单位法人/经营者:" prop="xsdwDwfr">
              <el-input
                v-model="form.xsdwDwfr"
                :disabled="gmsqtype"
                placeholder="请输入单位法人/经营者"
              />
            </el-form-item>
            <el-form-item label="单位座机:" prop="xsdwDwzj">
              <el-input
                v-model="form.xsdwDwzj"
                :disabled="gmsqtype"
                placeholder="请输入单位座机"
              />
            </el-form-item>
            <el-form-item label="单位地址:" prop="xsdwDwdz">
              <el-input
                v-model="form.xsdwDwdz"
                :disabled="gmsqtype"
                placeholder="请输入单位地址"
              />
            </el-form-item>
            <el-form-item label="联系人姓名:" prop="xsdwLxrxm">
              <el-input
                v-model="form.xsdwLxrxm"
                :disabled="gmsqtype"
                placeholder="请输入联系人姓名"
              />
            </el-form-item>
            <el-form-item label="联系人身份证:" prop="xsdwLxrsfzh">
              <el-input
                v-model="form.xsdwLxrsfzh"
                :disabled="gmsqtype"
                placeholder="请输入联系人身份证"
              />
            </el-form-item>
            <el-form-item label="联系人手机号:" prop="xsdwLxrsjhm">
              <el-input
                v-model="form.xsdwLxrsjhm"
                :disabled="gmsqtype"
                placeholder="请输入联系人手机号"
              />
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="imgtitle3">
        <img src="../../assets/img/xgcl.png" alt="">
      </div>
      <div class="tishi">
        <img src="../../assets/img/tishi.png" alt="">
        <p>
          提示：“营业执照复印件”和“其他组织的登记证书或者成立批准文件复印件”二选一即可；支持上传png、jpg、bmp格式，500KB以内证件照片。
        </p>
      </div>
      <div class="thirdbf">
        <ul class="uploadzhengjian">
          <li v-for="(item, i) in imgListArray" :key="i">
            <img
              v-preventReClick
              :src="item.imageurl"
              alt=""
              @click="imageClick(item.name, item.zjlx)"
            >

            <p v-preventReClick @click="xiazai($event)" v-html="item.tishi" />
          </li>
        </ul>
      </div>

      <div v-show="leixing == 'hx'" class="fourbf">
        <div class="imgtitle4">
          <img src="../../assets/img/gmsqzjhx.png" alt="">
        </div>
        <el-input
          v-model="hxyy"
          required
          type="textarea"
          :rows="6"
          resize="none"
          placeholder="请填写核销原因"
        />
      </div>
      <div class="footer">
        <template
          v-if="leixing == 'copy' || leixing == 'sq' || leixing == 'edit'"
        >
          <el-button
            v-preventReClick
            style="background: #ebebeb; color: black; border: none"
            @click="submitForm('form', 'zsbc')"
          >暂时保存</el-button>
          <el-button
            v-preventReClick
            style="background: #4170ff"
            type="primary"
            @click="submitForm('form', 'tj')"
          >提交申请</el-button>
        </template>
        <template v-else-if="leixing == 'view'">
          <el-button
            v-preventReClick
            style="background: #ebebeb; color: black; border: none"
            @click="submitForm('form', '')"
          >取消</el-button>
          <el-button
            v-preventReClick
            style="background: #4170ff"
            type="primary"
            @click="submitForm('form', '')"
          >确定</el-button>
        </template>
        <template v-else-if="leixing == 'hx'">
          <el-button
            v-preventReClick
            style="background: #ebebeb; color: black; border: none"
            @click="submitForm('form', 'qx')"
          >取消</el-button>
          <el-button
            v-preventReClick
            style="background: #4170ff"
            type="primary"
            @click="submitForm('form', 'qrhx')"
          >确认核销</el-button>
        </template>
      </div>
    </div>
    <hhwhc-dialog-inside
      ref="dialoghhwhcinside"
      :type="gmsqtype"
      :inner-visible="innerVisible"
      :xianshi="name"
      @dialog-inside="DialogInside"
      @dialog-inside1="DialogInside1"
    />
  </div>
</template>
<script>
// 获取接口地址
import {
  gethxpJl,
  addgmzMes,
  getgmzDwMes,
  addgmzwldwMes,
  getkv,
  jbrMes
} from '@/assets/js/common.js'
import hhwhcDialogInside from './hhwhcDialogInside.vue'
import {dealDataGy} from "@/utils/ppp";

export default {
  name: 'Gmsq',
  components: {
    hhwhcDialogInside
  },
  props: {
    dialogFormVisible: {
      type: Boolean
    },
    gmsqtype: {
      type: Boolean
    },
    leixing: {
      type: String
    }
  },
  data() {
    const gmslxg = (rule, value, callback) => {
      if (!this.form.gmsl) {
        callback(new Error('请输入数量'))
      } else if (!this.form.gmslDw) {
        callback(new Error('请选择单位'))
      } else {
        callback()
      }
    }
    const djxg = (rule, value, callback) => {
      if (!this.form.dj) {
        callback(new Error('请输入单价'))
      } else if (!this.form.djDw) {
        callback(new Error('请选择单位'))
      } else {
        callback()
      }
    }
    const zjxg = (rule, value, callback) => {
      if (!this.form.zj) {
        callback(new Error('请输入总价'))
      } else if (!this.form.zjDw) {
        callback(new Error('请选择单位'))
      } else {
        callback()
      }
    }
    const nxqlxg = (rule, value, callback) => {
      if (!this.form.nxql) {
        callback(new Error('请输入'))
      } else if (!this.form.nxqlDw) {
        callback(new Error('请选择单位'))
      } else {
        callback()
      }
    }
    const telphoneValidate = (rule, value, callback) => {
      if (!this.form.jbrSjh) {
        callback(new Error('手机号不能为空!'))
      } else if (value) {
        const reg = /^1[3456789]\d{9}$/
        if (!reg.test(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    const telphoneValidate1 = (rule, value, callback) => {
      if (!this.form.xsdwLxrsjhm) {
        callback(new Error('手机号不能为空!'))
      } else if (value) {
        const reg = /^1[3456789]\d{9}$/
        if (!reg.test(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      name: '', // 确认内层弹窗的内容
      // 许可证图片
      imgListArray: [
        {
          zjlx: 3,
          name: '合法使用证件',
          tishi:
            " * 合法使用需要证明原件<br/> <a style='color: #4170ff;cursor: pointer;'>下载模版</a>",
          imageurl: require('../../assets/img/gmsqhfsy.png')
        },
        {
          zjlx: 1,
          name: '营业执照复印件',
          tishi: '营业执照复印件',
          imageurl: require('../../assets/img/gmsqyyzz.png')
        },
        {
          zjlx: 2,
          tishi: '其他组织的登记证书或者成立<br/>批准文件复印',
          name: '登记证书',
          imageurl: require('../../assets/img/gmsqdjzs.png')
        },
        {
          zjlx: 7,
          name: '其他证件',
          tishi: ' 其他证件',
          imageurl: require('../../assets/img/qtzj2.png')
        }
      ],
      zjlxs: [], //
      innerVisible: false, // dialog是否显示
      hxyy: '',
      form: {
        // zt: "00", // 字典yzd_xkz_zt   00草稿  11 审批中
        hxpBm: '', // 化学品"102"
        hxpMc: '', // 化学品"102"
        gmsl: '', // 购买数量
        gmslDw: '', // 购买数量单位 "2"
        dj: '', // 单价
        djDw: '', // 单价单位
        zj: '', // 总价
        zjDw: '', // 总价单位
        nxql: '', // 年需求量
        nxqlDw: '', // 年需求量单位
        yt: '', // 用途
        gxhth: '', // ""购销合同号
        yxcs: '', // 有效次数
        jbrXm: '', // 经办人姓名
        jbrSfzh: '', // 经办人身份证
        jbrSjh: '', // 经办人手机号码
        bz: '', // 备注
        xsdwMc: '', // 单位名称
        xsdwTyshxydm: '', // 社会信用代码
        xsdwDwfr: '', // 销售单位法人/经营者姓名
        xsdwDwzj: '', // 销售单位单位座机
        xsdwDwdz: '', // 销售单位地址
        xsdwLxrxm: '', // 销售人员姓名
        xsdwLxrsfzh: '', // 销售人员身份证
        xsdwLxrsjhm: '', // 销售人员手机号码
        zt: ''
      },
      rules: {
        gmslxg: [{ required: true, validator: gmslxg, trigger: 'change' }],
        djxg: [{ required: true, validator: djxg, trigger: 'change' }],
        zjxg: [{ required: true, validator: zjxg, trigger: 'change' }],
        nxqlxg: [{ required: true, validator: nxqlxg, trigger: 'change' }],
        hxpBm: [
          {
            required: true,
            message: '请选择化学品',
            trigger: ['blur', 'change']
          }
        ],
        yt: [{ required: true, message: '请输入用途', trigger: 'blur' }],
        jbrXm: [
          { required: true, message: '请输入经办人姓名', trigger: 'blur' }
        ],
        jbrSfzh: [
          { required: true, message: '请输入经办人身份证', trigger: 'blur' },
          { min: 18, max: 18, message: '身份证格式有误', trigger: 'blur' }
        ],
        jbrSjh: [
          {
            required: true,
            validator: telphoneValidate,
            trigger: 'blur',
            min: 11,
            max: 11
          }
        ],
        xsdwMc: [
          {
            required: true,
            message: '请输入单位名称',
            trigger: ['blur', 'change']
          }
        ],
        xsdwLxrxm: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        xsdwLxrsfzh: [
          { required: true, message: '请输入身份证', trigger: 'blur' },
          { min: 18, max: 18, message: '身份证格式有误', trigger: 'blur' }
        ],
        xsdwLxrsjhm: [
          {
            required: true,
            validator: telphoneValidate1,
            trigger: 'blur',
            min: 11,
            max: 11
          }
        ]
      },
      options: [], // 化学品级联数据
      yzd_nsjsl_dw: [], // 单位信息
      yzd_zjzj: [], // 总价单价单位信息
      xkzGmFjxxList: [], // 许可证所有信息
      id: '', // 编辑需携带的id
      jbrList: []
    }
  },
  watch: {
    // 监听长度变化
    xkzGmFjxxList: {
      deep: true,
      handler(val) {
        this.xkzGmFjxxList = val
      }
    }
  },
  created() {
    jbrMes().then((e) => {
      this.jbrList = e.data.data
    })
    // 获取化学品级联数据
    gethxpJl().then((e) => {
      this.options = e.data.data
    })
    // 化学品数量单位
    getkv('yzd_nsjsl_dw').then((e) => {
      this.yzd_nsjsl_dw = e.data.data
    })
    // 单价总价单位
    getkv('yzd_xkzdjdw').then((e) => {
      this.yzd_zjzj = e.data.data
    })
  },
  mounted() {},
  methods: {
    back() {
      this.reset()
    },
    // 化学品级联改变   这个许可证还没有
    handleChange(value) {
      if (value == undefined) return
      this.form.hxpBm = value.slice(1).toString()

      this.options.forEach((item) => {
        if (item.value == value.slice(0, 1).toString()) {
          item.children.forEach((itemChidren) => {
            if (itemChidren.value == this.form.hxpBm) { this.form.hxpMc = itemChidren.label }
          })
        }
      })

      // 第一类  5张
      if (value.includes('100')) {
        this.imgListArray.filter((item, index) => {
          if (item.zjlx == 4) {
            this.imgListArray.splice(index, 1)
          }
          return this.imgListArray
        })
      }
      // 第二，三类  全部6张图片
      else {
        var flag = this.imgListArray.some((item, index) => {
          return item.zjlx == 4
        })

        flag == true
          ? ''
          : this.imgListArray.push({
            zjlx: 4,
            name: '购买单位经办人身份证复印件',
            tishi: '购买单位经办人身份证复印件',
            imageurl: require('../../assets/img/gmsqgmdw.png')
          })
      }
    },
    // 添加往来单位名称
    addDW(val) {
      if (val.length > 0) {
        this.$confirm('是否将该单位加入往来单位？', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          distinguishCancelAndClose: true,
          center: true,
          message: '是否将该单位加入往来单位？'
        })
          .then(() => {
            // 添加往来单位信息
            addgmzwldwMes({
              id: '', // 没有值为新增，有值为修改
              dwId: '',
              glrwdwId: '',
              dwmc: this.form.dwmc,
              ywlx: '1,2,3,4',
              ywlxLabel: '生产,使用,经营,运输',
              shtyxydm: this.form.xsdwShtyxydm,
              dwdz: this.form.xsdwDz,
              frmc: this.form.xsdwFrxm,
              dwzj: this.form.xsdwDwzj,
              dwsj: '',
              dwxz: null,
              dwlx: null,
              jycs: '0'
            }).then((e) => {
              this.$message({
                type: 'success',
                message: '添加成功!'
              })
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
      }
    },
    // 选择单位打开弹窗      选择的往来单位必须是“生产”或“使用”类单位
    selectdwmc() {
      this.innerVisible = true
      this.name = '单位'
    },
    // 根据往来单位带出信息
    getgmzDwMess(data) {
      getgmzDwMes(data).then((e) => {
        this.form.xsdwMc = e.data.data.dwmc
        this.form.xsdwTyshxydm = e.data.data.shtyxydm
        this.form.xsdwDwfr = e.data.data.frmc
        this.form.xsdwDwzj = e.data.data.dwzj
        this.form.xsdwDwdz = e.data.data.dwdz
      })
    },
    // 初始化表单内容
    getformMes(dataMes) {
      this.id = this.leixing == 'copy' ? '' : dataMes.id // 根据id来知道编辑的数据
      this.form = Object.assign(
        {},
        {
          hxpMc: dataMes.hxpMc,
          hxpBm: dataMes.hxpBm, // 化学品
          gmsl: dataMes.gmsl, // 购买数量
          gmslDw: dataMes.gmslDw, // 购买数量单位
          dj: dataMes.dj, // 单价
          djDw: dataMes.djDw, // 单价单位
          zj: dataMes.zj, // 总价
          zjDw: dataMes.zjDw, // 总价单位
          nxql: dataMes.nxql, // 年需求量
          nxqlDw: dataMes.nxqlDw, // 年需求量单位
          yt: dataMes.yt, // 用途
          gxhth: dataMes.gxhth, // ""购销合同号
          yxcs: dataMes.yxcs, // 有效次数
          jbrXm: dataMes.jbrXm, // 经办人姓名
          jbrSfzh: dataMes.jbrSfzh, // 经办人身份证
          jbrSjh: dataMes.jbrSjh, // 经办人手机号码
          bz: dataMes.bz, // 备注
          xsdwMc: dataMes.xsdwMc, // 单位名称
          xsdwTyshxydm: dataMes.xsdwTyshxydm, // 社会信用代码
          xsdwDwfr: dataMes.xsdwDwfr, // 销售单位法人/经营者姓名
          xsdwDwzj: dataMes.xsdwDwzj, // 销售单位单位座机
          xsdwDwdz: dataMes.xsdwDwdz, // 销售单位地址
          xsdwLxrxm: dataMes.xsdwLxrxm, // 销售人员姓名
          xsdwLxrsfzh: dataMes.xsdwLxrsfzh, // 销售人员身份证
          xsdwLxrsjhm: dataMes.xsdwLxrsjhm // 销售人员手机号码
        }
      )
      this.xkzGmFjxxList = dataMes.xkzGmFjxxList // 附件信息
      this.gxhthImage(this.form.gxhth)
      this.handleChange([this.form.hxpBm.slice(0, 1) + '00', this.form.hxpBm])
    },
    // 保存表单添加和修改的数据
    async addgmzMess(dataObj) {
      dataObj.vdata = await dealDataGy()
      addgmzMes(dataObj).then((e) => {
        // 获取购买申请表信息，保存后进行查询刷新列表
        this.$parent.search()
      })
    },
    // 经办人
    jbrChange(val) {
      this.jbrList.some((item) => {
        if (item.id == val) {
          this.form.jbrSfzh = item.zjhm
          this.form.jbrSjh = item.sjhm
        }
      })
    },
    // 清空所有数据
    reset() {
      this.id = ''
      this.xkzGmFjxxList = []
      this.imgListArray = [
        {
          zjlx: 3,
          name: '合法使用证件',
          tishi:
            " * 合法使用需要证明原件<br/> <a style='color: #4170ff;cursor: pointer;'>下载模版</a>",
          imageurl: require('../../assets/img/gmsqhfsy.png')
        },
        {
          zjlx: 1,
          name: '营业执照复印件',
          tishi: '营业执照复印件',
          imageurl: require('../../assets/img/gmsqyyzz.png')
        },
        {
          zjlx: 2,
          tishi: '其他组织的登记证书或者成立<br/>批准文件复印',
          name: '登记证书',
          imageurl: require('../../assets/img/gmsqdjzs.png')
        },
        {
          zjlx: 7,
          name: '其他证件',
          tishi: ' 其他证件',
          imageurl: require('../../assets/img/qtzj2.png')
        }
      ]
      this.form = {}
      this.$nextTick(() => {
        this.$refs['form'].clearValidate(['gmslxg', 'djxg', 'nxqlxg', 'zjxg'])
        this.$refs['form'].resetFields()
      })
      this.$emit('close-dialog') // 关闭
    },
    // 提交表单内容
    submitForm(formName, type) {
      // type:tj zsbc
      // 如果是不可编辑，不需要验证
      if (this.gmsqtype == true) {
        if (this.leixing == 'hx' && type == 'qrhx') {
          if (this.hxyy == '' || this.hxyy.length == 0) {
            this.$message({
              type: 'error',
              message: '请填写原因'
            })
            return false
          } else {
            this.$confirm('确认取消核销吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            })
              .then(() => {
                this.reset()
                this.$message({
                  type: 'success',
                  message: '取消成功!'
                })
              })
              .catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消'
                })
              })
          }
        } else this.reset()
        return
      }
      // 许可证必传三个中的两个
      var zjlxs = []
      var mes = []
      if (this.xkzGmFjxxList.length > 0) {
        this.xkzGmFjxxList.forEach((item, index) => {
          item.zjlx && item.gmFjList.length > 0
            ? zjlxs.push(parseInt(item.zjlx))
            : ''
        })
      }
      if (zjlxs.includes(3)) {
      } else mes.push('合法使用证件')
      if (zjlxs.includes(1) || zjlxs.includes(2)) {
      } else mes.push('营业执照复印件 或 其他组织的登记证书或者成立')

      // 编辑和复制新增需要验证
      this.$refs[formName].validate((valid, obj) => {
        if (valid && mes.length == 0) {
          this.zt = type == 'zsbc' ? '00' : '11'
          var data = {
            id: this.id || '',
            hxpMc: this.form.hxpMc || '',
            hxpBm: this.form.hxpBm || '', // 化学品
            gmsl: this.form.gmsl || '', // 购买数量
            gmslDw: this.form.gmslDw || '', // 购买数量单位
            dj: this.form.dj || '', // 单价
            djDw: this.form.djDw || '', // 单价单位
            zj: this.form.zj || '', // 总价
            zjDw: this.form.zjDw || '', // 总价单位
            nxql: this.form.nxql || '', // 年需求量
            nxqlDw: this.form.nxqlDw || '', // 年需求量单位
            yt: this.form.yt || '', // 用途
            gxhth: this.form.gxhth || '', // ""购销合同号
            yxcs: this.form.yxcs || '', // 有效次数
            jbrXm: this.form.jbrXm || '', // 经办人姓名
            jbrSfzh: this.form.jbrSfzh || '', // 经办人身份证
            jbrSjh: this.form.jbrSjh || '', // 经办人手机号码
            bz: this.form.bz || '', // 备注
            xsdwMc: this.form.xsdwMc || '', // 单位名称
            xsdwTyshxydm: this.form.xsdwTyshxydm || '', // 社会信用代码
            xsdwDwfr: this.form.xsdwDwfr || '', // 销售单位法人/经营者姓名
            xsdwDwzj: this.form.xsdwDwzj || '', // 销售单位单位座机
            xsdwDwdz: this.form.xsdwDwdz || '', // 销售单位地址
            xsdwLxrxm: this.form.xsdwLxrxm || '', // 销售人员姓名
            xsdwLxrsfzh: this.form.xsdwLxrsfzh || '', // 销售人员身份证
            xsdwLxrsjhm: this.form.xsdwLxrsjhm || '', // 销售人员手机号码
            xkzGmFjxxList: this.xkzGmFjxxList,
            zt: this.zt
          }
          if (type == 'tj') {
            this.$confirm('此操作将保存该数据，不可撤回, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            })
              .then(() => {
                this.$message({
                  type: 'success',
                  message: '提交成功!'
                })
                this.addgmzMess(data) // 提交
                this.reset()
              })
              .catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消'
                })
              })
          } else if (type == 'zsbc') {
            this.$confirm('此操作将暂时保存该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            })
              .then(() => {
                this.$message({
                  type: 'success',
                  message: '保存成功!'
                })
                this.addgmzMess(data) // 提交
                this.reset()
              })
              .catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消'
                })
              })
          } else {
            this.reset()
          }
        } else {
          mes.length == 0
            ? ''
            : this.$message({
              type: 'error',
              message: '请补全' + mes.toString() + '信息'
            })
          return false
        }
      })
    },
    // 许可证弹窗
    imageClick(name, zjlx) {
      this.name = name
      this.innerVisible = true
      // console.log(this.xkzGmFjxxList, "xkzGmFjxxList");
      // 筛选出证件类型符合的数据
      var arr = this.xkzGmFjxxList.filter((item, index, arr) => {
        return item.zjlx == zjlx
      })

      // console.log(arr[0], "arr[0]");
      this.$refs.dialoghhwhcinside.cshYm(arr[0], zjlx)
    },
    // 许可证变化 //有了购销合同号才有购销合同证件
    gxhthImage(val) {
      if (val == '') {
        this.imgListArray.filter((item, index) => {
          if (item.zjlx == 6) {
            this.imgListArray.splice(index, 1)
          }
          return this.imgListArray
        })
      } else {
        var flag = this.imgListArray.some((item, index) => {
          return item.zjlx == 6
        })
        flag == true
          ? ''
          : this.imgListArray.push({
            zjlx: 6,
            tishi: '购销合同证件',
            name: '购销合同证件',
            imageurl: require('../../assets/img/gmsqgxht.png')
          })
      }
    },
    // 下载
    xiazai(event) {
      if (event.target.innerText.toString() == '下载模版') {
        console.log(123)
      }
    },
    // 关闭许可证弹窗
    DialogInside(val) {
      if (!this.gmsqtype && val != undefined) {
        // this.xkzGmFjxxList含有这个证件类型de信息和图片
        var flag = this.xkzGmFjxxList.some((item, index, arr) => {
          return item.zjlx == val.zjlx
        })
        flag == true
          ? this.xkzGmFjxxList.filter((item, index, arr) => {
            if (item.zjlx == val.zjlx) {
              this.xkzGmFjxxList.splice(index, 1, val)
            }
          })
          : val.gmFjList.length > 0
            ? this.xkzGmFjxxList.push(val)
            : ''
      }
      // console.log(val, "vla");
      // console.log(this.xkzGmFjxxList, "DialogInside");
      this.innerVisible = false
    },
    // 关闭单位弹窗
    DialogInside1(val) {
      this.innerVisible = false
      if (this.name == '单位' && val != '') {
        // 得到选择的单位信息
        this.getgmzDwMess(val) // 根据往来单位带出信息
      }
    }
  }
}
</script>
<style lang="less" scoped>
.gmsqDialog {
  width: 95%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0;
  background-color: #fff;

  .imgtitle1,
  .imgtitle2,
  .imgtitle3 {
    padding: 40px 117px;
    img {
      height: 22px;
    }
  }
  .imgtitle1 {
    img {
      width: 145px;
    }
  }
  .imgtitle2 {
    img {
      width: 127px;
    }
  }
  .imgtitle3 {
    padding: 40px 117px 28px 117px;
    img {
      width: 91px;
    }
  }

  .formmes {
    /deep/ .el-form {
      .firstbf,
      .secondbf {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 0 117px 40px;
        border-bottom: 10px solid #eef1f9;

        .el-form-item {
          margin-right: 0px;
          margin-bottom: 20px;
          height: 39px;
          width: 47% !important;
          // .el-form-item__label {
          //   text-align: left;
          // }
          .el-form-item__content {
            display: flex;
          }
          .el-switch {
            height: 39px;
          }
        }
      }
      .firstbf {
        .el-form-item {
          .el-form-item__label {
            width: 118px;
          }
          &:nth-child(2) {
            .el-input__suffix {
              right: 20px;
            }
            .el-input__icon::before {
              content: "%";
              width: 15px;
              height: 21px;
              font-size: 15px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              line-height: 21px;
            }
          }

          &:nth-child(1),
          &:nth-child(10) {
            .el-form-item__content {
              .el-select {
                width: 100% !important;
              }
            }
          }

          &:nth-child(3),
          &:nth-child(4),
          &:nth-child(5),
          &:nth-child(6) {
            .el-form-item__content {
              & > .el-input {
                margin-right: 10px;
              }
            }
          }

          &:nth-child(13) {
            width: 100% !important;
          }
        }
      }
      .secondbf {
        .el-form-item {
          &:nth-child(1),
          &:nth-child(3),
          &:nth-child(5),
          &:nth-child(7) {
            .el-form-item__label {
              width: 118px;
            }
          }
          &:nth-child(2),
          &:nth-child(4),
          &:nth-child(6),
          &:nth-child(8) {
            .el-form-item__label {
              width: 135px;
            }
          }
          &:nth-child(2) {
            .el-form-item__label {
              width: 138px;
            }
          }
          &:nth-child(1) {
            .el-form-item__content {
              // width: 340px;
              .el-input {
                // width: 268px;
              }
              .el-button--primary {
                // width: 65px;
                margin-left: 7px;
              }
            }
          }

          &:nth-child(2),
          &:nth-child(3),
          &:nth-child(4),
          &:nth-child(5),
          &:nth-child(6),
          &:nth-child(7),
          &:nth-child(8) {
            .el-form-item__content {
              // width: 340px;
            }
            .el-select {
              width: 100% !important;
            }
          }
        }
      }
    }
  }
  .tishi {
    padding: 0 117px 31px;

    img {
      width: 15px;
      height: 15px;
      margin-right: 5px;
      vertical-align: middle;
    }
    p {
      display: inline-block;
      height: 18px;
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #636363;
      line-height: 18px;
    }
  }
  .thirdbf {
    padding: 0 117px;
    .uploadzhengjian {
      display: flex;
      flex-wrap: wrap;
      padding: 0;
      margin: 0;
      text-align: center;

      li {
        width: 202px;
        margin-right: 50px;
        list-style: none;
        &:nth-child(4n) {
          margin-right: 0;
        }
        img {
          width: 202px;
          height: 138px;
        }
        p {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 18px;
          a {
            cursor: pointer;
          }
        }
      }
    }
  }
  .fourbf {
    border-top: 10px solid #eef1f9;
    padding: 40px 117px 0;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #aeaeae;
    line-height: 21px;
    .imgtitle4 {
      margin-bottom: 30px;
      img {
        width: 91px;
        height: 22px;
      }
    }
    .el-textarea__inner:focus {
      outline: 0;
      border-color: #dcdfe6;
    }
  }
  .footer {
    padding: 70px 0 47px;
    text-align: center;
    .el-button {
      width: 148px;
      height: 60px;
      margin: 0 95px;
    }
  }
}
/deep/ .el-message-box {
  width: 518px !important;
  height: 270px;
}
</style>
